var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brush-stroke-bg inline-flex items-center justify-center text-center bg-cover bg-center bg-no-repeat leading-none px-6",style:(_vm.bgStyle)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }